import { useState, useRef } from "react";
import { Copy, Edit, Save, X } from "lucide-react";
import useUserStore from "../../store/useUserStore";
import NoSleep from "nosleep.js";
import "./SurgicalNotes.css";
import { CircularProgress } from "@mui/material";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import useSurgicalStore from "../../store/useSurgicalStore";


const SurgicalNotes = ({ surgicalNote }) => {
  const { isMobile } = useUserStore();
  const [isLoading, setisLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedSurgicalNote, setEditedSurgicalNote] = useState("");
  const noSleep = useRef(new NoSleep());
  const {surgicalId,getSurgicalDetail} = useSurgicalStore();

  const copySurgicalNote = () => {
    navigator.clipboard.writeText(surgicalNote);
  };

  const handleEdit = () => {
    setIsEditing(true);
    setEditedSurgicalNote(surgicalNote);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    if (editedSurgicalNote === surgicalNote) {
      handleCancel()
      return
    }

    await updateSurgicalNote(surgicalId, editedSurgicalNote).catch((error) => {
      console.error("Error in updating surgical note:", error);
      setisLoading(false);
      setIsEditing(false);
    });

    setisLoading(false);
    setIsEditing(false);
  }


  const updateSurgicalNote = async (surgical_id, content) => {
    noSleep.current.enable()
    setisLoading(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/surgical-note/updatefile/${surgicalId}`;

    // Convert string to Blob and create a File object
    const blob = new Blob([content], { type: "text/plain" });
    const file = new File(
      [blob],
      `surgical_note_${surgicalId}.txt`,
      { type: "text/plain" }
    );

    // Prepare FormData
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        setisLoading(false);
        noSleep.current.disable()
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      getSurgicalDetail(surgicalId)
      console.log("File updated successfully:", result);
      setisLoading(false);
      noSleep.current.disable()

    } catch (error) {
      setisLoading(false);
      noSleep.current.disable()
      console.error("Error updating surgical note file:", error);
    }
  };

  return (
    <div className="surgical-container">
      {!isLoading && (
        <div className="surgical-actions">
          {isEditing ? (
            <>
              <button className="surgical-action-button" onClick={handleCancel}>
                <X size={isMobile ? 14 : 18} />
                Cancel
              </button>
              <button
                className="surgical-action-button save-button"
                onClick={handleSave}
              >
                <Save size={isMobile ? 14 : 18} />
                Save
              </button>
            </>
          ) : (
            <>
              <button
                className="surgical-action-button"
                onClick={copySurgicalNote}
              >
                <Copy size={isMobile ? 14 : 18} />
                Copy
              </button>
              <button className="surgical-action-button" onClick={handleEdit}>
                <Edit size={isMobile ? 14 : 18} />
                Edit
              </button>
            </>
          )}
        </div>
      )}

      {!isLoading && (
        <div className="surgical-content">
          {isEditing ? (
            <textarea
              value={editedSurgicalNote}
              onChange={(e) => setEditedSurgicalNote(e.target.value)}
              className="summary-editor"
            />
          ) : (
            <Markdown
              remarkPlugins={[remarkGfm]}
              className="surgical-markdown-content"
            >
              {surgicalNote}
            </Markdown>
          )}
        </div>
      )}
      {isLoading && (
        <CircularProgress
          size={60}
          sx={{ position: "relative", top: "35%", left: "40%" }}
        />
      )}
    </div>
  );
};

export default SurgicalNotes;
